export default {
  rates: ({ rates }) => rates,
};
